import React from "react";

var MailIcon = function MailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.595c-.715 0-1.43-.153-2.095-.46L0 8.563V20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V8.563l-9.905 4.572c-.665.307-1.38.46-2.095.46zM22 2H2a2 2 0 0 0-2 2v2.36l10.743 4.958a2.999 2.999 0 0 0 2.515 0L24 6.36V4a2 2 0 0 0-2-2z"
  }));
};

MailIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
MailIcon.defaultProps.solid = true;
export default MailIcon;